import script from "./SmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmModal.vue?vue&type=script&lang=ts&setup=true"

import "./SmModal.vue?vue&type=style&index=0&id=ebbb0d92&lang=scss"

const __exports__ = script;

export default __exports__